<script setup>
import { useMapGetter } from 'dashboard/composables/store.js';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  to: { type: [Object, String], default: '' },
  label: { type: String, default: '' },
  icon: { type: [String, Object], default: '' },
  expandable: { type: Boolean, default: false },
  isExpanded: { type: Boolean, default: false },
  isActive: { type: Boolean, default: false },
  hasActiveChild: { type: Boolean, default: false },
  getterKeys: { type: Object, default: () => ({}) },
  // Add these new props for external links
  external: { type: Boolean, default: false },
  externalUrl: { type: String, default: '' },
  openInNewPage: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);

const showBadge = useMapGetter(props.getterKeys.badge);

const handleClick = event => {
  if (props.external && props.externalUrl) {
    event.preventDefault();
    event.stopPropagation();

    if (props.openInNewPage) {
      window.open(props.externalUrl, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = props.externalUrl;
    }
  } else {
    emit('toggle');
  }
};
</script>

<template>
  <component
    :is="to && !external ? 'router-link' : 'div'"
    class="flex items-center gap-2 px-2 py-1.5 rounded-lg h-8 cursor-pointer"
    role="button"
    :to="to && !external ? to : undefined"
    :title="label"
    :class="{
      'n-blue-text bg-n-alpha-2 font-medium':
        isActive && !hasActiveChild && !external,
      'text-n-slate-12 font-medium': hasActiveChild && !external,
      'text-n-slate-11 hover:bg-n-alpha-2':
        !isActive && !hasActiveChild && !external,
      // Custom styling for external button
      'text-white bg-green-600 hover:bg-green-700 font-medium':
        external && label === 'Заполнить договор',
      'text-white bg-indigo-600 hover:bg-indigo-700 font-medium':
        external && label === 'DB_portal',
    }"
    @click="handleClick"
  >
    <div v-if="icon" class="relative flex items-center gap-2">
      <Icon v-if="icon" :icon="icon" class="size-4" />
      <span
        v-if="showBadge"
        class="size-2 -top-px ltr:-right-px rtl:-left-px bg-n-brand absolute rounded-full border border-n-solid-2"
      />
    </div>
    <span class="text-sm font-medium leading-5 flex-grow">
      {{ label }}
    </span>
    <span
      v-if="expandable"
      v-show="isExpanded"
      class="i-lucide-chevron-up size-3"
      @click.stop="emit('toggle')"
    />
  </component>
</template>
